import UpdateIOUAdjustmentGeneral from "../UpdateIOUAdjustmentGeneral/UpdateIOUAdjustmentGeneral";

const ViewIOUAdjustmentGeneral = (props) => {
  return <UpdateIOUAdjustmentGeneral {...props} viewMode={true} />;
};

export default ViewIOUAdjustmentGeneral;
